import React from 'react';
import _t from 'counterpart';
import { CCard, CCardBody, CCardHeader, CCardTitle, CCol, CDataTable, CRow, CBadge } from '@coreui/react';
import { IWallet, TradingType, WalletStatus } from '../../types';
import Loading from '../../components/Loading';
import { formatCurrency } from '../../helpers';

interface CustomerWalletsTableProps {
  wallets: Array<IWallet>;
}

function CustomerWalletsTable({ wallets }: CustomerWalletsTableProps) {
  const data = wallets;
  const isLoading = false;

  if (isLoading) {
    return <Loading />;
  }

  if (!data || data.length === 0) {
    return null;
  }

  return (
    <CRow>
      <CCol md={12}>
        <CCard className="card card--listing">
          <CCardBody className="card__holder">
            <CCardHeader className="card__header">
              <div className="card__info">
                <h4 className="card__title">{_t('customer.wallets.title')}</h4>
              </div>
            </CCardHeader>
            <CDataTable
              loading={isLoading}
              items={data || []}
              fields={[
                { key: 'status', label: _t('global.status') },
                { key: 'isDemo', label: _t('global.type') },
                { key: 'info', label: _t('customer.wallets.accountId') },
                { key: 'currency', label: _t('customer.wallets.currency') },
                { key: 'balance', label: _t('customer.wallets.balance') },
                { key: 'credit', label: _t('customer.wallets.credit') },
                { key: 'group', label: _t('wallet-modal.group') },
                { key: 'tradingType', label: _t('wallets.trading-type') },
              ]}
              scopedSlots={{
                info: (wallet: IWallet) => (
                  <td>
                    <div>{wallet.id}</div>
                    <div className="small text-medium-emphasis">{wallet.type}</div>
                  </td>
                ),
                tradingType: (wallet: IWallet) => (
                  <td>
                    <CBadge
                      style={{ backgroundColor: wallet.tradingType === TradingType.Netting ? '#18B8C2' : '#9618C2' }}
                    >
                      {wallet.tradingType === TradingType.Netting ? _t('wallets.netting') : _t('wallets.hedging')}
                    </CBadge>
                  </td>
                ),
                isDemo: (wallet: IWallet) => (
                  <td>
                    <CBadge color={wallet.isDemo ? 'danger' : 'success'}>{wallet.isDemo ? 'DEMO' : 'REAL'}</CBadge>
                  </td>
                ),
                balance: (wallet: IWallet) => (
                  <td style={{ width: '10%' }}>
                    {wallet.status === WalletStatus.Active && wallet.balance
                      ? formatCurrency(wallet.balance, wallet.currency)
                      : 'n/a'}
                  </td>
                ),
                credit: (wallet: IWallet) => (
                  <td style={{ width: '10%' }}>
                    {wallet.status === WalletStatus.Active && wallet.credit
                      ? formatCurrency(wallet.credit, wallet.currency)
                      : 'n/a'}
                  </td>
                ),
                group: (wallet: IWallet) => <td>{wallet.group?.name || '-'}</td>,
                status: (wallet: IWallet) => (
                  <td>
                    <CBadge color={wallet.status.toLowerCase()}>{wallet.status}</CBadge>
                    {wallet.primary && <br />}
                    {wallet.primary && <CBadge color="primary">PRIMARY</CBadge>}
                  </td>
                ),
              }}
              hover
              striped
              itemsPerPage={10}
              pagination
            />
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );
}

export default CustomerWalletsTable;
